
import React, { useEffect }  from "react";
import './ErrorPortalComponent.scss';

const ErrorPortalComponent = ({globalError,hideErrorOverlay,translations}) => {

  useEffect(()=>{
    if(globalError.show){
      $(document).foundation();
      var backGroundLayer = document.getElementsByClassName('reveal-modal-bg')[0];
      backGroundLayer && backGroundLayer.parentNode.removeChild(backGroundLayer);
      $('#globalError').foundation('reveal','open');
    }
  },[globalError.show])

  if (!globalError.show) return null;

  return (
    <div className="error_info_layer">
      <div id="disc-tool-tip" style={{display: "none"}}>
        <div id="tray-options" className="disconnect">
          <div className="content icon-icon-low-resolution">{translations["int_disconnect_msg"]}</div>
        </div>
      </div>
      <div role="dialog" id="globalError" data-reveal-listen data-reveal className="small reveal-modal" aria-labelledby="errorHeader" aria-modal="true">
          <div className="confirmation-body">
              <div className="confirmation-header confirm-header-nobg">
                  <h2 id="errorHeader" className="error-info-text">{translations["Error"]["unexpected_from_snappy"]}</h2>
              </div>
              <div className="confirmation-wrapper">
                  <p className="error-body-text">{translations["Error"]["error_body_text"]}</p>
                  <div className="error_detail"><p className="error_id_text" style={{display: "inline-block"}}>{translations["Error"]["error_id"]}</p> <p className="globalError_noodle" style={{display: "inline-block"}}>{globalError.noodle} <br></br>{globalError.errorMessage} <br></br> {globalError.errorId}</p></div>
                  <a href="javascript:void(0)" className="close-reveal-modal" aria-label={translations["aria_label"]["close"]} onClick={hideErrorOverlay}></a>
                  <ul className="btn_desktop">
                    {(photoOrg.config.contact_us_url) ?
                      <li className="pill-border contact-us-link"><a target="_blank" href={photoOrg.config.contact_us_url} role="button" title={translations["Error"]["contact_us"]}>{translations["Error"]["contact_us"]}</a></li>
                    :
                      <li className="pill ok-button-navigation"><a fixfocus href="javascript:void(0)" title={translations["ok_more"]} role="button">{translations["ok_more"]}</a></li>
                    }
                  </ul>
                  <ul className="btn_mobile">
                      <li className="pill ok-button-navigation"><a href="javascript:void(0)" title={translations["ok_more"]} role="button">{translations["ok_more"]}</a></li>
                      {(photoOrg.config.contact_us_url) ?
                          <li className="pill-border contact-us-link"><a target="_blank" href={photoOrg.config.contact_us_url} title={translations["Error"]["contact_us"]}>{translations["Error"]["contact_us"]}</a></li>
                      : null }
                  </ul>
              </div>
          </div>
      </div>
    </div>);
}

export default ErrorPortalComponent;
